var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_ring"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 86",
    d: "M13.9795 22.75C12.6991 22.75 11.4313 22.4978 10.2483 22.0078C9.0654 21.5178 7.99057 20.7997 7.0852 19.8943C6.17983 18.9889 5.46165 17.9141 4.97167 16.7312C4.48168 15.5482 4.22949 14.2804 4.22949 13C4.22949 11.7196 4.48168 10.4518 4.97167 9.26884C5.46165 8.08591 6.17983 7.01108 7.0852 6.10571C7.99057 5.20034 9.06541 4.48216 10.2483 3.99217C11.4313 3.50219 12.6991 3.25 13.9795 3.25C15.2599 3.25 16.5277 3.50219 17.7107 3.99218C18.8936 4.48216 19.9684 5.20034 20.8738 6.10571C21.7792 7.01108 22.4973 8.08591 22.9873 9.26884C23.4773 10.4518 23.7295 11.7196 23.7295 13C23.7295 14.2804 23.4773 15.5482 22.9873 16.7312C22.4973 17.9141 21.7792 18.9889 20.8738 19.8943C19.9684 20.7997 18.8936 21.5178 17.7107 22.0078C16.5277 22.4978 15.2599 22.75 13.9795 22.75L13.9795 22.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 112",
    d: "M10.7295 9.75L17.2295 16.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 113",
    d: "M17.2295 9.75L10.7295 16.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRing);
export default __webpack_public_path__ + "static/media/closeRing.9e2b2f184f4fce8ef77f402d242b3b3a.svg";
export { ForwardRef as ReactComponent };